export default {
  backgroundImage: 'background_2.png',
  eventDate: 'Ended November 21st 2022',
  title1: 'PennyLane',
  title2: 'Code Camp',
  subTitle: `Thanks for participating!`,
  subTitle2: ``
}
